
export const ROUTE_STRENGTH_MAP = {
  "Oral": [
    "0.125 mg", "0.25 mg", "0.5 mg", "1 mg", "2 mg", "2.5 mg", "5 mg", "10 mg", "20 mg", "25 mg", "50 mg", "75 mg", "100 mg", "200 mg", "250 mg", "400 mg", "500 mg", "850 mg", "1000 mg", "2000 mg", "5000 mg", "7500 mg", "10000 mg"
  ],
  "Subcutaneous (SubQ) Injection": [
    "0.1 mg", "0.25 mg", "0.5 mg", "1 mg", "2 mg", "5 mg", "10 mg", "20 mg", "25 mg", "50 mg", "75 mg", "100 mg", "200 mg", "250 mg", "400 mg", "500 mg", "850 mg", "1000 mg", "2000 mg", "5000 mg", "7500 mg", "10000 mg", "75 IU", "150 IU", "250 IU", "500 IU", "1000 IU", "5000 IU", "10000 IU"
  ],
  "IM Injection": [
    "0.1 mg", "0.25 mg", "0.5 mg", "1 mg", "2 mg", "5 mg", "10 mg", "20 mg", "25 mg", "50 mg", "75 mg", "100 mg", "200 mg", "250 mg", "400 mg", "500 mg", "850 mg", "1000 mg", "2000 mg", "5000 mg", "7500 mg", "10000 mg", "75 IU", "150 IU", "250 IU", "500 IU", "1000 IU", "5000 IU", "10000 IU"
  ],
  "IM": [
    "0.1 mg", "0.25 mg", "0.5 mg", "1 mg", "2 mg", "5 mg", "10 mg", "20 mg", "25 mg", "50 mg", "75 mg", "100 mg", "200 mg", "250 mg", "400 mg", "500 mg", "850 mg", "1000 mg", "2000 mg", "5000 mg", "7500 mg", "10000 mg", "75 IU", "150 IU", "250 IU", "500 IU", "1000 IU", "5000 IU", "10000 IU"
  ],
  "SubQ": [
    "0.1 mg", "0.25 mg", "0.5 mg", "1 mg", "2 mg", "5 mg", "10 mg", "20 mg", "25 mg", "50 mg", "75 mg", "100 mg", "200 mg", "250 mg", "400 mg", "500 mg", "850 mg", "1000 mg", "2000 mg", "5000 mg", "7500 mg", "10000 mg", "75 IU", "150 IU", "250 IU", "500 IU", "1000 IU", "5000 IU", "10000 IU"
  ],
  "Vaginal": [
    "100 mg", "200 mg", "400 mg", "8% gel (~90 mg)", "100 mg suppository", "200 mg suppository", "250 mg", "500 mg"
  ],
  "Rectal": [
    "100 mg suppository", "200 mg suppository", "250 mg", "500 mg"
  ],
  "Transdermal": [
    "0.025 mg", "0.05 mg", "0.075 mg", "0.1 mg"
  ],
  "Transdermal (Patch)": [
    "0.025 mg", "0.05 mg", "0.075 mg", "0.1 mg"
  ],
  "Sublingual": [
    "0.25 mg", "0.5 mg", "1 mg", "2 mg"
  ],
  "Intranasal": [
    "0.1 mg", "0.2 mg", "0.5 mg per spray"
  ],
  "Intrauterine": [
    "10 mg", "20 mg"
  ],
  "Other": [
    "20 mg", "40 mg", "60 mg", "81 mg", "325 mg", "1 g"
  ]
};

// Unified medication mapping for routes and strengths
export const MEDICATION_DATA_MAP = {
  "Clomiphene Citrate": { routes: ["Oral"], strengths: ["25 mg", "50 mg"] },
  "Letrozole": { routes: ["Oral"], strengths: ["2.5 mg"] },
  "Follitropin alfa": { routes: ["Subcutaneous (SubQ) Injection"], strengths: ["75 IU", "150 IU", "225 IU", "300 IU"] },
  "Follitropin beta": { routes: ["Subcutaneous (SubQ) Injection"], strengths: ["75 IU", "150 IU", "225 IU"] },
  "Menotropins": { routes: ["IM Injection", "SubQ"], strengths: ["75 IU", "150 IU", "300 IU"] },
  "Human Chorionic Gonadotropin (hCG)": { routes: ["SubQ", "IM"], strengths: ["1,000 IU", "5,000 IU", "10,000 IU"] },
  "Leuprolide acetate": { routes: ["SubQ", "IM"], strengths: ["0.1 mg", "1 mg", "3.75 mg", "7.5 mg"] },
  "Ganirelix acetate": { routes: ["SubQ"], strengths: ["0.25 mg"] },
  "Cetrorelix": { routes: ["SubQ"], strengths: ["0.25 mg"] },
  "Progesterone": { routes: ["Oral", "Vaginal", "Rectal", "IM", "SubQ", "Intrauterine"], strengths: ["100 mg", "200 mg", "400 mg (oral)", "8% gel (~90 mg)", "100 mg suppository", "200 mg suppository", "50 mg/mL IM", "10 mg IU device"] },
  "Estradiol": { routes: ["Oral", "Transdermal", "Vaginal", "IM", "Subcutaneous implant", "Intranasal"], strengths: ["0.5 mg", "1 mg", "2 mg (oral)", "0.025 mg patch", "0.05 mg patch", "0.1 mg patch", "25 µg intranasal", "2 mg/mL IM"] },
  "Medroxyprogesterone acetate": { routes: ["Oral", "IM"], strengths: ["2.5 mg", "5 mg", "10 mg (oral)", "150 mg/mL IM", "400 mg/mL IM"] },
  "Dydrogesterone": { routes: ["Oral"], strengths: ["10 mg"] },
  "Anastrozole": { routes: ["Oral"], strengths: ["1 mg"] },
  "Tamoxifen": { routes: ["Oral"], strengths: ["10 mg", "20 mg"] },
  "hMG (human menopausal gonadotropin)": { routes: ["IM", "SubQ"], strengths: ["75 IU", "150 IU", "300 IU"] },
  "Levothyroxine": { routes: ["Oral"], strengths: ["25 µg", "50 µg", "75 µg", "100 µg", "125 µg", "150 µg", "200 µg"] },
  "Liothyronine": { routes: ["Oral"], strengths: ["5 µg", "25 µg", "50 µg"] },
  "Metformin": { routes: ["Oral"], strengths: ["500 mg", "850 mg", "1000 mg"] },
  "Low-dose Aspirin": { routes: ["Oral"], strengths: ["81 mg"] },
  "Heparin": { routes: ["SubQ", "IV"], strengths: ["5,000 units/mL"] },
  "Enoxaparin": { routes: ["SubQ"], strengths: ["30 mg/0.3 mL", "40 mg/0.4 mL", "60 mg/0.6 mL", "80 mg/0.8 mL", "100 mg/1 mL"] },
  "Prednisone": { routes: ["Oral"], strengths: ["1 mg", "5 mg", "10 mg", "20 mg", "50 mg"] },
  "Cabergoline": { routes: ["Oral"], strengths: ["0.5 mg"] },
  "Bromocriptine": { routes: ["Oral"], strengths: ["2.5 mg"] },
  "Doxycycline": { routes: ["Oral", "IV"], strengths: ["100 mg (oral)", "100 mg/5 mL IV"] },
  "Azithromycin": { routes: ["Oral", "IV"], strengths: ["250 mg", "500 mg (oral)", "500 mg/5 mL IV"] },
  "Atorvastatin": { routes: ["Oral"], strengths: ["10 mg", "20 mg", "40 mg", "80 mg", "20 mg/5 mL suspension"] },
  "Lisinopril": { routes: ["Oral"], strengths: ["2.5 mg", "5 mg", "10 mg", "20 mg", "30 mg", "40 mg"] },
  "Amlodipine": { routes: ["Oral"], strengths: ["2.5 mg", "5 mg", "10 mg"] },
  "Metoprolol": { routes: ["Oral"], strengths: ["25 mg", "50 mg", "100 mg"] },
  "Albuterol": { routes: ["Inhalation", "Oral"], strengths: ["90 mcg/inhalation", "2 mg oral"] },
  "Losartan": { routes: ["Oral"], strengths: ["25 mg", "50 mg", "100 mg"] },
  "Omeprazole": { routes: ["Oral"], strengths: ["10 mg", "20 mg", "40 mg"] },
  "Gabapentin": { routes: ["Oral"], strengths: ["100 mg", "300 mg", "400 mg", "600 mg", "800 mg"] },
  "Sertraline": { routes: ["Oral"], strengths: ["25 mg", "50 mg", "100 mg"] },
  "Hydrochlorothiazide": { routes: ["Oral"], strengths: ["12.5 mg", "25 mg", "50 mg", "100 mg"] },
  "Rosuvastatin": { routes: ["Oral"], strengths: ["5 mg", "10 mg", "20 mg", "40 mg"] },
  "Amphetamine/Dextroamphetamine": { routes: ["Oral"], strengths: ["5 mg", "10 mg", "15 mg", "20 mg", "25 mg", "30 mg"] },
  "Escitalopram": { routes: ["Oral"], strengths: ["5 mg", "10 mg", "20 mg"] },
  "Pantoprazole": { routes: ["Oral"], strengths: ["20 mg", "40 mg"] },
  "Montelukast": { routes: ["Oral"], strengths: ["4 mg", "5 mg", "10 mg"] },
  "Trazodone": { routes: ["Oral"], strengths: ["50 mg", "100 mg", "150 mg", "300 mg"] },
  "Simvastatin": { routes: ["Oral"], strengths: ["5 mg", "10 mg", "20 mg", "40 mg", "80 mg"] },
  "Tamsulosin": { routes: ["Oral"], strengths: ["0.4 mg", "0.8 mg"] },
  "Bupropion": { routes: ["Oral"], strengths: ["75 mg", "150 mg", "300 mg"] },
  "Fluoxetine": { routes: ["Oral"], strengths: ["10 mg", "20 mg", "40 mg", "60 mg"] },
  "Acetaminophen/Hydrocodone": { routes: ["Oral"], strengths: ["325 mg / 5 mg", "500 mg / 5 mg"] },
  "Furosemide": { routes: ["Oral", "IV"], strengths: ["20 mg", "40 mg", "80 mg", "10 mg/mL IV"] },
  "Piperacillin/Tazobactam": { routes: ['IV'], strengths: ['2.25 g', '3.375 g', '4.5 g'] },
  "Cefepime": { routes: ['IV'], strengths: ['1 g', '2 g'] },
  "Meropenem": { routes: ['IV'], strengths: ['500 mg', '1 g'] },
  "Imipenem/Cilastatin": { routes: ['IV'], strengths: ['500 mg / 500 mg'] },
  "Ertapenem": { routes: ['IV'], strengths: ['1 g'] },
  "Tigecycline": { routes: ['IV'], strengths: ['50 mg'] },
  "Colistimethate": { routes: ['IV'], strengths: ['150 mg'] },
  "Caspofungin": { routes: ['IV'], strengths: ['50 mg', '70 mg'] },
  "Micafungin": { routes: ['IV'], strengths: ['50 mg', '100 mg'] },
  "Voriconazole": { routes: ['Oral', 'IV'], strengths: ['200 mg oral', '200 mg IV'] },
  "Posaconazole": { routes: ['Oral', 'IV'], strengths: ['100 mg', '300 mg'] },
  "Acyclovir": { routes: ['Oral', 'IV'], strengths: ['200 mg', '400 mg', '800 mg', '5% cream'] },
  "Valganciclovir": { routes: ['Oral'], strengths: ['450 mg'] },
  "Ganciclovir": { routes: ['IV'], strengths: ['500 mg'] },
  "Foscarnet": { routes: ['IV'], strengths: ['500 mg/250 mL'] },
  "Cidofovir": { routes: ['IV'], strengths: ['75 mg/mL'] },
  "Ritonavir": { routes: ['Oral'], strengths: ['100 mg'] },
  "Lopinavir/Ritonavir": { routes: ['Oral'], strengths: ['200 mg / 50 mg'] },
  "Tenofovir": { routes: ['Oral'], strengths: ['300 mg'] },
  "Emtricitabine": { routes: ['Oral'], strengths: ['200 mg'] },
  "Abacavir": { routes: ['Oral'], strengths: ['300 mg'] },
  "Lamivudine": { routes: ['Oral'], strengths: ['150 mg', '300 mg'] },
  "Dolutegravir": { routes: ['Oral'], strengths: ['50 mg'] },
  "Raltegravir": { routes: ['Oral'], strengths: ['400 mg'] },
  "Warfarin": { routes: ['Oral'], strengths: ['1 mg', '2 mg', '2.5 mg', '3 mg', '4 mg', '5 mg', '6 mg', '7.5 mg', '10 mg'] },
  "Fondaparinux": { routes: ['SubQ'], strengths: ['2.5 mg', '5 mg', '7.5 mg', '10 mg'] },
  "Alteplase": { routes: ['IV'], strengths: ['2 mg', '50 mg', '100 mg'] },
  "Tranexamic Acid": { routes: ['Oral', 'IV'], strengths: ['650 mg oral', '100 mg/mL IV'] },
  "Acetaminophen": { routes: ['Oral', 'IV'], strengths: ['325 mg', '500 mg', '650 mg', '1,000 mg'] },
  "Ibuprofen": { routes: ['Oral', 'IV'], strengths: ['200 mg', '400 mg', '600 mg', '800 mg'] },
  "Ketorolac": { routes: ['Oral', 'IV', 'IM'], strengths: ['10 mg oral', '30 mg/mL IV/IM'] },
  "Morphine": { routes: ['Oral', 'IV', 'IM'], strengths: ['15 mg', '30 mg', '60 mg', '100 mg'] },
  "Hydromorphone": { routes: ['Oral', 'IV', 'IM'], strengths: ['2 mg', '4 mg', '8 mg'] },
  "Oxycodone/Acetaminophen": { routes: ['Oral'], strengths: ['5 mg / 325 mg', '10 mg / 325 mg'] },
  "Methadone": { routes: ['Oral', 'IV', 'IM'], strengths: ['5 mg', '10 mg', '40 mg'] },
  "Buprenorphine": { routes: ['Sublingual', 'Transdermal'], strengths: ['2 mg', '8 mg', '5 mcg/hr', '10 mcg/hr', '20 mcg/hr'] },
  "Naltrexone": { routes: ['Oral', 'IM'], strengths: ['50 mg oral', '380 mg IM'] },
  "Naloxone": { routes: ['IV', 'IM', 'SubQ', 'Intranasal'], strengths: ['0.4 mg/mL', '2 mg/2 mL', '4 mg nasal'] },
 
  "Propylthiouracil": { routes: ['Oral'], strengths: ['50 mg', '100 mg'] },
  "Methimazole": { routes: ['Oral'], strengths: ['5 mg', '10 mg'] },
  "Alendronate": { routes: ['Oral'], strengths: ['5 mg', '10 mg', '35 mg', '70 mg'] },
  "Raloxifene": { routes: ['Oral'], strengths: ['60 mg'] },
  "Teriparatide": { routes: ['SubQ'], strengths: ['20 mcg'] },
  "Calcitonin": { routes: ['Nasal', 'IM', 'SubQ'], strengths: ['200 IU nasal', '100 IU/mL injection'] },
  "Dapagliflozin": { routes: ['Oral'], strengths: ['5 mg', '10 mg'] },
  "Exenatide": { routes: ['SubQ'], strengths: ['5 mcg', '10 mcg'] },
  "Liraglutide": { routes: ['SubQ'], strengths: ['6 mg/mL'] },
  "Semaglutide": { routes: ['SubQ', 'Oral'], strengths: ['2 mg SubQ', '7 mg oral', '14 mg oral'] },
  "Canagliflozin": { routes: ['Oral'], strengths: ['100 mg', '300 mg'] },
  "Miglitol": { routes: ['Oral'], strengths: ['25 mg', '50 mg', '100 mg'] },
  "Acarbose": { routes: ['Oral'], strengths: ['25 mg', '50 mg', '100 mg'] },
  "Erythromycin": { routes: ['Oral', 'IV'], strengths: ['250 mg', '500 mg'] },
  "Clarithromycin": { routes: ['Oral'], strengths: ['250 mg', '500 mg'] },
  "Fidaxomicin": { routes: ['Oral'], strengths: ['200 mg'] },
  "Chloramphenicol": { routes: ['Oral', 'IV'], strengths: ['250 mg', '500 mg'] },
  "Tetracycline": { routes: ['Oral'], strengths: ['250 mg', '500 mg'] },
  "Minocycline": { routes: ['Oral'], strengths: ['50 mg', '100 mg'] },
  "Levofloxacin": { routes: ['Oral', 'IV'], strengths: ['250 mg', '500 mg', '750 mg'] },
  "Moxifloxacin": { routes: ['Oral', 'IV'], strengths: ['400 mg'] },
  "Rifampin": { routes: ['Oral', 'IV'], strengths: ['300 mg', '600 mg'] },
  "Isoniazid": { routes: ['Oral'], strengths: ['100 mg', '300 mg'] },
  "Ethambutol": { routes: ['Oral'], strengths: ['400 mg'] },
  "Pyrazinamide": { routes: ['Oral'], strengths: ['500 mg'] },
  "Amantadine": { routes: ['Oral'], strengths: ['100 mg'] },
  "Oseltamivir": { routes: ['Oral'], strengths: ['30 mg', '45 mg', '75 mg'] },
  "Peramivir": { routes: ['IV'], strengths: ['600 mg'] },
  "Trimethoprim/Sulfamethoxazole": { routes: ['Oral', 'IV'], strengths: ['80 mg / 400 mg', '160 mg / 800 mg'] },
  "Hydrochlorothiazide/Lisinopril": { routes: ['Oral'], strengths: ['10 mg / 12.5 mg', '20 mg / 12.5 mg'] },
  "Atenolol": { routes: ['Oral'], strengths: ['25 mg', '50 mg', '100 mg'] },
  "Chlorthalidone": { routes: ['Oral'], strengths: ['12.5 mg', '25 mg', '50 mg'] },
  "Spironolactone/HCTZ": { routes: ['Oral'], strengths: ['25 mg / 25 mg', '50 mg / 50 mg'] },
  "Hydralazine/Isosorbide Dinitrate": { routes: ['Oral'], strengths: ['37.5 mg / 20 mg'] },
  "Duloxetine/Fluoxetine": { routes: ['Oral'], strengths: ['20 mg / 80 mg'] },
  "Nortriptyline": { routes: ['Oral'], strengths: ['10 mg', '25 mg', '50 mg', '75 mg'] },
  "Desipramine": { routes: ['Oral'], strengths: ['25 mg', '50 mg', '75 mg', '100 mg', '150 mg'] },
  "Chlorpromazine": { routes: ['Oral', 'IM', 'IV'], strengths: ['25 mg', '50 mg', '100 mg'] },
  "Paliperidone": { routes: ['Oral', 'IM'], strengths: ['3 mg', '6 mg', '9 mg'] },
  "Ziprasidone": { routes: ['Oral', 'IM'], strengths: ['20 mg', '40 mg', '60 mg', '80 mg'] },
  "Armodafinil": { routes: ['Oral'], strengths: ['150 mg', '250 mg'] },
  "Modafinil": { routes: ['Oral'], strengths: ['100 mg', '200 mg'] },
  "Selegiline": { routes: ['Oral', 'Transdermal'], strengths: ['5 mg oral', '6 mg patch'] },
  "Entacapone": { routes: ['Oral'], strengths: ['200 mg'] },
  "Tolcapone": { routes: ['Oral'], strengths: ['100 mg', '200 mg'] },
  "Pramipexole": { routes: ['Oral'], strengths: ['0.125 mg', '0.25 mg', '0.5 mg', '1 mg', '1.5 mg'] },
  "Ropinirole": { routes: ['Oral'], strengths: ['0.25 mg', '0.5 mg', '1 mg', '2 mg', '3 mg', '4 mg', '5 mg'] },
  "Baclofen": { routes: ['Oral'], strengths: ['5 mg', '10 mg', '20 mg'] },
  "Tizanidine": { routes: ['Oral'], strengths: ['2 mg', '4 mg', '6 mg'] },
  "Benztropine": { routes: ['Oral', 'IM', 'IV'], strengths: ['0.5 mg', '1 mg', '2 mg'] },
  "Trihexyphenidyl": { routes: ['Oral'], strengths: ['2 mg', '5 mg'] },
  "Memantine": { routes: ['Oral'], strengths: ['5 mg', '10 mg'] },
  "Donepezil": { routes: ['Oral'], strengths: ['5 mg', '10 mg', '23 mg'] },
  "Galantamine": { routes: ['Oral'], strengths: ['4 mg', '8 mg', '12 mg'] },
  "Rivastigmine": { routes: ['Oral', 'Transdermal'], strengths: ['1.5 mg', '3 mg', '4.5 mg', '6 mg', '9.5 mg patch', '13.3 mg patch'] },
  "Hydroxychloroquine": { routes: ['Oral'], strengths: ['200 mg'] },
  "Sulfasalazine": { routes: ['Oral'], strengths: ['500 mg'] },
  "Azathioprine": { routes: ['Oral'], strengths: ['50 mg', '100 mg'] },
  "Mycophenolate Mofetil": { routes: ['Oral'], strengths: ['250 mg', '500 mg'] },
  "Tacrolimus": { routes: ['Oral'], strengths: ['0.5 mg', '1 mg', '5 mg'] },
  "Sirolimus": { routes: ['Oral'], strengths: ['0.5 mg', '1 mg', '2 mg'] },
  "Everolimus": { routes: ['Oral'], strengths: ['2.5 mg', '5 mg', '7.5 mg', '10 mg'] },
  "Cyclophosphamide": { routes: ['Oral', 'IV'], strengths: ['25 mg', '50 mg', '500 mg', '1 g'] },
  "Methyldopa": { routes: ['Oral'], strengths: ['250 mg', '500 mg'] },
  "Isosorbide Mononitrate": { routes: ['Oral'], strengths: ['30 mg', '60 mg', '120 mg'] },
  "Isosorbide Dinitrate": { routes: ['Oral'], strengths: ['5 mg', '10 mg', '20 mg', '30 mg', '40 mg'] },
  "Nitroglycerin": { routes: ['Sublingual', 'Transdermal', 'IV'], strengths: ['0.3 mg', '0.4 mg', '0.6 mg', '5 mg patch'] },
  "Ranibizumab": { routes: ['Intravitreal'], strengths: ['0.5 mg'] },
  "Bevacizumab": { routes: ['IV'], strengths: ['100 mg', '400 mg'] },
  "Pegfilgrastim": { routes: ['SubQ'], strengths: ['6 mg'] },
  "Romiplostim": { routes: ['SubQ'], strengths: ['1 mcg', '10 mcg'] },
  "Penicillin V Potassium": { routes: ['Oral'], strengths: ['250 mg', '500 mg'] },
  "Amoxicillin/Clavulanate": { routes: ['Oral'], strengths: ['500 mg / 125 mg', '875 mg / 125 mg'] },
  "Cefuroxime": { routes: ['Oral'], strengths: ['250 mg', '500 mg'] },
  "Ceftriaxone": { routes: ['IV', 'IM'], strengths: ['500 mg', '1 g', '2 g'] },
  "Nitrofurantoin": { routes: ['Oral'], strengths: ['50 mg', '100 mg'] },
  "Linezolid": { routes: ['Oral', 'IV'], strengths: ['600 mg'] },
  "Vancomycin": { routes: ['Oral', 'IV'], strengths: ['125 mg', '250 mg', '500 mg', '1 g'] },
  "Albendazole": { routes: ['Oral'], strengths: ['200 mg', '400 mg'] },
  "Ivermectin": { routes: ['Oral'], strengths: ['3 mg', '6 mg', '12 mg'] },
  "Naproxen": { routes: ['Oral'], strengths: ['250 mg', '500 mg'] },
  "Celecoxib": { routes: ['Oral'], strengths: ['100 mg', '200 mg'] },
  "Valsartan": { routes: ['Oral'], strengths: ['40 mg', '80 mg', '160 mg', '320 mg'] },
  "Olmesartan": { routes: ['Oral'], strengths: ['5 mg', '20 mg', '40 mg'] },
  "Telmisartan": { routes: ['Oral'], strengths: ['20 mg', '40 mg', '80 mg'] },
  "Amlodipine/Benazepril": { routes: ['Oral'], strengths: ['2.5 mg / 10 mg', '5 mg / 20 mg'] },
  "Labetalol": { routes: ['Oral', 'IV'], strengths: ['100 mg', '200 mg', '300 mg'] },
  "Doxazosin": { routes: ['Oral'], strengths: ['1 mg', '2 mg', '4 mg', '8 mg'] },
  "Nifedipine": { routes: ['Oral'], strengths: ['10 mg', '20 mg', '30 mg', '60 mg'] },
  "Ezetimibe": { routes: ['Oral'], strengths: ['10 mg'] },
  "Fenofibrate": { routes: ['Oral'], strengths: ['48 mg', '145 mg'] },
  "Glipizide": { routes: ['Oral'], strengths: ['5 mg', '10 mg'] },
  "Sitagliptin": { routes: ['Oral'], strengths: ['25 mg', '50 mg', '100 mg'] },
  "Empagliflozin": { routes: ['Oral'], strengths: ['10 mg', '25 mg'] },
  "Insulin Glargine": { routes: ['SubQ'], strengths: ['100 units/mL', '300 units/mL'] },
  "Insulin Lispro": { routes: ['SubQ'], strengths: ['100 units/mL'] },
  "Sucralfate": { routes: ['Oral'], strengths: ['1 g'] },
  "Famotidine": { routes: ['Oral', 'IV'], strengths: ['20 mg', '40 mg'] },
  "Lansoprazole": { routes: ['Oral'], strengths: ['15 mg', '30 mg'] },
  "Mesalamine": { routes: ['Oral', 'Rectal'], strengths: ['400 mg oral', '1 g rectal'] },
  "Salbutamol (Albuterol)": { routes: ['Inhalation'], strengths: ['100 mcg/puff'] },
  "Formoterol": { routes: ['Inhalation'], strengths: ['12 mcg'] },
  "Tiotropium": { routes: ['Inhalation'], strengths: ['18 mcg'] },
  "Paroxetine": { routes: ['Oral'], strengths: ['10 mg', '20 mg', '30 mg', '40 mg'] },
  "Desvenlafaxine": { routes: ['Oral'], strengths: ['50 mg', '100 mg'] },
  "Lithium Carbonate": { routes: ['Oral'], strengths: ['150 mg', '300 mg', '600 mg'] },
  "Quetiapine": { routes: ['Oral'], strengths: ['25 mg', '50 mg', '100 mg', '200 mg', '300 mg', '400 mg'] },
  "Haloperidol": { routes: ['Oral', 'IM', 'IV'], strengths: ['0.5 mg', '1 mg', '2 mg', '5 mg', '10 mg', '20 mg'] },
  "Levonorgestrel": { routes: ['Oral', 'Intrauterine'], strengths: ['0.75 mg', '1.5 mg', '52 mg IU device'] },

  "Hydroxyurea": { routes: ['Oral'], strengths: ['500 mg'] },
  "Filgrastim": { routes: ['SubQ', 'IV'], strengths: ['300 mcg', '480 mcg'] },
  "Epoetin alfa": { routes: ['SubQ', 'IV'], strengths: ['2,000 IU', '3,000 IU', '4,000 IU', '10,000 IU'] },
  "Dabigatran": { routes: ['Oral'], strengths: ['75 mg', '110 mg', '150 mg'] },
  "Rivaroxaban": { routes: ['Oral'], strengths: ['2.5 mg', '10 mg', '15 mg', '20 mg'] },
  "Apixaban": { routes: ['Oral'], strengths: ['2.5 mg', '5 mg'] }
};

// All available routes
export const ALL_ROUTES = [
  "Oral", "Subcutaneous (SubQ) Injection", "IM Injection", "IM", "SubQ", "Vaginal", "Rectal", "Transdermal", "Transdermal (Patch)", "Sublingual", "Intranasal", "Intrauterine", "IV", "Intravenous (IV)", "Inhalation", "Subcutaneous implant", "Subcutaneous implant", "Other"
];

// Default strengths for medications
export const DEFAULT_STRENGTHS = [
  // Micrograms (mcg)
  "25 mcg", "50 mcg", "75 mcg", "100 mcg", "125 mcg", "200 mcg", "250 mcg",
  // Milligrams (mg)
  "0.025 mg", "0.05 mg", "0.1 mg", "0.2 mg", "0.25 mg", "0.5 mg",
  "1 mg", "2 mg", "2.5 mg", "3.75 mg", "5 mg", "10 mg", "20 mg", "25 mg",
  "45 mg", "50 mg", "75 mg", "90 mg", "100 mg", "200 mg", "250 mg",
  "400 mg", "500 mg", "850 mg", "1000 mg", "2000 mg", "5000 mg", "7500 mg",
  "10000 mg", "11250 mg",
  // International Units (IU)
  "75 IU", "150 IU", "300 IU", "450 IU", "500 IU", "600 IU", "900 IU",
  "1000 IU", "5000 IU", "10000 IU",
  // Concentrations
  "20 mg/mL", "50 mg/mL", "100 mg/mL", "10000 units/mL"
];

